export const buyers = [
  { name: "Valentina R.", place: "Bogotá, Colombia" },
  { name: "Sofía M.", place: "Guadalajara, Mexico" },
  { name: "Lucía F.", place: "Madrid, Spain" },
  { name: "Camila P.", place: "Buenos Aires, Argentina" },
  { name: "Mateo G.", place: "Santiago, Chile" },
  { name: "Daniela V.", place: "Lima, Peru" },
  { name: "Isabella C.", place: "Montevideo, Uruguay" },
  { name: "Andrés L.", place: "Quito, Ecuador" },
  { name: "Gabriela S.", place: "Caracas, Venezuela" },
  { name: "Mariana T.", place: "San José, Costa Rica" },
  { name: "Javier N.", place: "Santo Domingo, Dominican Republic" },
  { name: "Paula A.", place: "Panama City, Panama" },
  { name: "Carolina D.", place: "Asunción, Paraguay" },
  { name: "Fernanda O.", place: "La Paz, Bolivia" },
  { name: "Elena B.", place: "Barcelona, Spain" },
  { name: "Renata H.", place: "Monterrey, Mexico" },
  { name: "Ana Lucía Q.", place: "Guatemala City, Guatemala" },
  { name: "Diego R.", place: "Medellín, Colombia" },
];
